import React,{Component} from 'react';
import '../App.css';

class BottomBar extends Component{
    state = {
        bottomButton:[
            {"id":0,"name":"Home","url":"/images/red_repicthousebase.png","pageLink":"/library"},
            {"id":1,"name":"Search","url":"/images/searchIcon.png","pageLink":"/search/allbooks"},
            //{"id":2,"name":"Saved","url":"./images/savedIcon.png"},
            //{"id":3,"name":"Account","url":"./images/userIcon.png"},
        ],
        divWidth: null,
    }

    componentDidMount() {
        this.setState({
            divWidth: this.container.offsetWidth
        });
      }

    render()
    {
        const { divWidth } = this.state;

        return(
            <div className='bottomBar' ref={el => (this.container = el)}>
                {divWidth && this.renderFooter()}
            </div>
        )
    }

    renderFooter()
    {
        const { divWidth } = this.state;

        if (divWidth < 700)
        {
            return(
                <div>
                    {
                        this.state.bottomButton.map((item,index) =>(
                            <button className='btmbtn' onClick={() => this.gotoPage(item.pageLink)} key = {item.id}>
                                <img
                                    style={this.styles.imageGap}
                                    src={item.url}
                                    alt=''
                                />
                                {/* <p style={this.styles.textName}>{item.name}</p> */}
                            </button>
                        ))   
                    }
                    <div style={{paddingTop:'5px'}}>
                        <div><a href="mailto:support@celexmedia.com" style={{fontSize:'12px', textDecoration:'none'}}>support@celexmedia.com</a></div>
                        <div style={{fontSize:'12px'}}>Copyright © 2020 Celex Media Sdn Bhd. All Rights Reserved.</div>
                    </div>
                </div>
            )
        }

        else
        {
            return(
                <div style={{minWidth:"700px"}}>
                    {
                        this.state.bottomButton.map((item,index) =>(
                            <button className='btmbtn' onClick={() => this.gotoPage(item.pageLink)} key = {item.id}>
                                <img
                                    style={this.styles.imageGap}
                                    src={item.url}
                                    alt=''
                                />
                                {/* <p style={this.styles.textName}>{item.name}</p> */}
                            </button>
                        ))   
                    }
                    <div style={{paddingTop:'5px'}}>
                        <div><a href="mailto:support@celexmedia.com" style={{fontSize:'12px', textDecoration:'none'}}>support@celexmedia.com</a></div>
                        <div style={{fontSize:'12px'}}>Copyright © 2020 Celex Media Sdn Bhd. All Rights Reserved.</div>
                    </div>
                </div>
            )
        }
    }

    gotoPage = (pageLink) =>
    {
        console.log(pageLink)
        this.props.history.push(pageLink)
    }

    styles =
    {
        bottomBar :{
            flex:1,
            width: "100%",
            justifyContent: 'center',
            position:"relative" , 
            zIndex : 1, 
            //bottom:0,
            paddingBottom:60,
            //paddingTop:10,
            backgroundColor:"#F8F8F8",
            flexDirection: 'row',
            shadowColor: '#000',
            shadowOffset: { width: 0, height: -12 },
            shadowOpacity: 0.5,
            elevation: 2,

        },

        imageGap :{
            width: 35, 
            height: 35 , 
            marginLeft:20 , 
            marginRight:20,
            paddingTop: 5,
        },

        textName:
        {
            alignSelf:"center",
            fontSize:14,
            margin: 5, 
        },

        // button:
        // {
        //     border: 'none',
        //     backgroundColor: 'rgba(224, 224, 224, 0)',
        //     cursor: 'pointer'
        // }
    }

}


export default BottomBar